import { Box, Typography } from '@mui/material'
import React from 'react'

interface ITitleProps {
    intitule: string;
}


export default function Title(props: ITitleProps) {
    const { intitule } = props
    return (
        <Box sx={{ width: "auto",display:"flex" }}>
            <Typography style={{ marginTop: 15 }} variant='h6' >{`${intitule}`}</Typography> 
        </Box>
    )
}
